module.exports = __webpack_public_path__ + "static/media/academy.bd814b42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/academy.jpg
// module id = 1307
// module chunks = 0